import gql from "graphql-tag";

export interface GetNewInProductsVariables {
  categoryIn?: number[];
}

export interface GetMostWatchedProductsVariables {
  category?: string;
  categoryIn?: number[];
}

export interface GetTopSalesProductsVariables {
  categoryIn?: number[];
}

export interface GetHomeBlogPostsVariables {
  categoryIn?: number[];
}

export const getNewInProducts = gql`
  query getNewInProducts($categoryIn: [Int]) {
    products(where: { stockStatus: IN_STOCK, categoryIdIn: $categoryIn, orderby: { field: DATE, order: DESC } }, first: 9) {
      nodes {
        id
        databaseId
        slug
        type
        ... on VariableProduct {
          id
          name
          regularPrice
          salePrice
          onSale
          variations(first: 100, where: {stockStatus: IN_STOCK}) {
            nodes {
              id
              databaseId
              stockQuantity
              image {
                slug
              }
              attributes {
                nodes {
                  id
                  name
                  value
                }
              }
            }
          }
        }
        ... on SimpleProduct {
          id
          name
          stockQuantity
          regularPrice
          salePrice
          onSale
        }
        productCategories {
          nodes {
            id
            slug
            name
            databaseId
          }
        }
        image {
          id
          mediaItemUrl
          sourceUrl(size: _630X500)
        }
      }
    }
  }
`;

export const getProductSale = gql`
  query ProductSale {
    generalOptions {
      generalOptions {
        homeAds {
          bannerSliderCampaigns {
            __typename
          }
        }
      }
    }
  }
`;

export const getMostWatchedProducts = gql`
  query getMostWatchedProducts($category: String, $categoryIn: [Int]) {
    products(where: { category: $category, categoryIdIn: $categoryIn, stockStatus: IN_STOCK }, first: 9) {
      nodes {
        id
        slug
        databaseId
        type

        ... on VariableProduct {
          id
          name
          regularPrice
          salePrice
          onSale
          variations(first: 100, where: {stockStatus: IN_STOCK}) {
            nodes {
              id
              databaseId
              stockQuantity
              image {
                slug
              }
              attributes {
                nodes {
                  id
                  name
                  value
                }
              }
            }
          }
        }
        ... on SimpleProduct {
          id
          name
          stockQuantity
          regularPrice
          salePrice
          onSale
        }
        productCategories {
          nodes {
            id
            slug
            name
            databaseId
          }
        }
        image {
          id
          mediaItemUrl
          sourceUrl(size: _630X500)
        }
      }
    }
  }
`;

export const getNotifications = gql`
  query getNotifications($userId: String!) {
    notifications(where: { userId: $userId }, first: 50) {
      nodes {
        id
        title
        slug
        link
        content
        notificationData {
          orderId
          thumbnailUrl
          read
          customLink
          userId
        }
      }
    }
  }
`;

export const markAsReadNotification = gql`
  mutation markAsReadNotificationMutation($userId: String!) {
    markNotificationAsRead(input: { userId: $userId }) {
      clientMutationId
      message
    }
  }
`;

export const GET_TOP_SALES_PRODUCTS = gql`
  query getTopSalesProducts($categoryIn: [Int]) {
    products(where: { stockStatus: IN_STOCK, categoryIdIn: $categoryIn, orderby: { field: TOTAL_SALES } }, first: 9) {
      nodes {
        id
        slug
        databaseId
        type
        ... on VariableProduct {
          id
          name
          regularPrice
          salePrice
          onSale
          variations(first: 100, where: { stockStatus: IN_STOCK }) {
            nodes {
              id
              databaseId
              stockQuantity
              image {
                slug
              }
              attributes {
                nodes {
                  id
                  name
                  value
                }
              }
            }
          }
        }
        ... on SimpleProduct {
          id
          name
          type
          stockStatus
          stockQuantity
          regularPrice
          salePrice
          onSale
        }
        productCategories {
          nodes {
            id
            slug
            name
            databaseId
          }
        }
        image {
          id
          mediaItemUrl
          sourceUrl(size: _630X500)
        }
      }
    }
  }
`;

export const GET_HOT_SALES_PRODUCTS = gql`
  query getHotSalesProducts {
    hotSales {
      id
      name
      price
      sale_price
      slug
      stockQuantity
      type
      thumbnailUrl
      uri
    }
  }
`;

//TODO: update this
export const getHomeBlogPosts = gql`
  query getBestSellers($categoryIn: [String]) {
    products(where: { onSale: true, categoryIn: $categoryIn, stockStatus: IN_STOCK }, first: 3) {
      nodes {
        id
        slug
        databaseId
        ... on VariableProduct {
          id
          name
          regularPrice
          salePrice
          onSale
          price(format: FORMATTED)
        }
        ... on SimpleProduct {
          id
          name
          regularPrice
          salePrice
          onSale
          price(format: FORMATTED)
        }
        productCategories {
          nodes {
            id
            slug
            name
          }
        }
        image {
          id
          mediaItemUrl
          sourceUrl(size: _630X500)
        }
      }
    }
  }
`;

export const getCourses = gql`
  query getCourses($courseCategoryId: String, $productBrandId: String) {
    courses(
      first: 100
      where: {
        courseCategoryId: $courseCategoryId
        productBrandId: $productBrandId
      }
    ) {
      nodes {
        id
        databaseId
        content
        slug
        title
        featuredImage {
          node {
            mediaItemUrl
            slug
            id
          }
        }
        courseDoc {
          document {
            link
            id
          }
        }
        productBrands {
          nodes {
            name
            id
          }
        }
        courseVideo {
          video
        }
      }
    }
  }
`;

export const getCoursesCategories = gql`
  query getCoursesCategories {
    courseCategories {
      nodes {
        id
        name
        slug
        databaseId
      }
    }
  }
`;

export const getCourseById = gql`
  query getCourseById($id: ID!) {
    course(id: $id) {
      id
      databaseId
      content
      slug
      title
      featuredImage {
        node {
          id
          mediaItemUrl
          slug
        }
      }
      courseDoc {
        document {
          link
          id
        }
      }
      productBrands {
        nodes {
          name
          id
        }
      }
      courseVideo {
        video
      }
    }
  }
`;
